<template>
    <div style="display: flex; flex-grow: 1;">
        <div
            style="font-size: 16px; text-transform: none; text-align: left; flex-grow: 1; padding-left: 0px; margin-right: 12px;">
            <span @click="$router.push('/').catch(() => {})" style="font-weight: 600; "><slot></slot></span>
            <span @click="$router.push('/').catch(() => {})" style="font-size: 11px;" v-if="!hideBy && !simple"> by DentiCalc</span>
        </div>
        <span v-if="$packageName === 'com.denticalc.4in1' && !IAP.hasPremiumAccess() && $route.path==='/'"
              style="background: #fff; text-align: center; color: #0e8fc8; border-radius: 20px; padding: 4px 14px 4px 14px; font-size: 11px; letter-spacing: -0.25px; font-weight: 600; display: flex; align-items: center"
              @click="onUpgrade">

            <template v-if="showDiscount">
                70% OFF
            </template>
            <template v-else>
                SUBSCRIBE NOW!
            </template>
        </span>
        <!--span
            v-if="$router.currentRoute.path==='/'"
            style="background: #fff; text-align: center; color: #233; border-radius: 20px; padding: 4px 14px 4px 14px; font-size: 11px; letter-spacing: -0.25px; font-weight: 900; display: flex; align-items: center"
            @click="openBrightPlans"
        >
            Try BrightPlans
        </span-->
    </div>
</template>
<script>
import { trialDaysLeft } from "@/utils/iap/trial-days";
import { isDiscountEligible } from "@/utils/promo-offer";
export default {
    props: {
        simple: {
            type: Boolean,
            default: false,
        },
        hideBy: {
            type: Boolean,
            default: false,
        }
    },
    data: () => ({
        IAP: window.IAP,
        trialDaysLeft: trialDaysLeft(),
        showDiscount: false,
    }),
    created() {
        this.registerBusEvent("flutter:updateFirstRunTS", () => {
            this.trialDaysLeft = trialDaysLeft();
        });
        this.showDiscount = isDiscountEligible();
        this.registerBusEvent("updateAppBar", () => {
            this.showDiscount = isDiscountEligible();
            this.trialDaysLeft = trialDaysLeft();
            this.$forceUpdate();
        });
    },
    methods: {
        openBrightPlans() {
            this.$router.push("/brightplans");
        },
        onUpgrade() {
            // this.$bus.$emit('free_trial:show', { countdown: 0, route: 'home' });
            this.$bus.$emit('openAppDialog','premium',{'title': '', 'referrer': 'click_app_bar'});

            window.Tracker.logEvent({
                event_name: "show_premium",
                event_category: "iap",
                event_label: "app_bar",
            });

            const interestedToUpgrade = parseInt(localStorage.getItem('interestedToUpgrade') || '0', 10) + 1;

            localStorage.setItem('interestedToUpgrade', String(interestedToUpgrade));
        },
    },
}
</script>
